import { combineReducers, createReducer, PayloadAction } from "@reduxjs/toolkit";

import { IAddressValidation } from "Model/State/IAddressValidation";
import {
  addressValidationDialog,
  addressValidationStart,
  addressValidationSuccess,
  addressValidationCacheSet,
  addressValidationActiveProjectItemIdSelect,
  addressValidationActiveProjectIdSelect,
  projectsClear
} from "Store/Actions";
import { hasNoElements } from "Utils/Array";
import { IProject } from "Model/Storage/IProject";
import { IAddressValidationResult } from "Model/Omikron/IAddressValidationResult";

const showDialog = createReducer(false, {
  [addressValidationDialog.type]: (_, { payload }: PayloadAction<boolean>) => payload,
  [projectsClear.type]: () => false
});

const activeProjectId = createReducer<string>(null, {
  [addressValidationActiveProjectIdSelect.type]: (_, { payload: id }) => id,
  [addressValidationDialog.type]: (state, { payload: isOpen }: PayloadAction<boolean>) => (isOpen ? state : null),
  [projectsClear.type]: () => null
});

const activeProjectItemId = createReducer<string>(null, {
  [addressValidationActiveProjectItemIdSelect.type]: (_, { payload: id }) => id,
  [addressValidationDialog.type]: (state, { payload: isOpen }: PayloadAction<boolean>) => (isOpen ? state : null),
  [projectsClear.type]: () => null
});

const results = createReducer<IAddressValidationResult[][]>([], {
  [addressValidationStart.type]: () => [],
  [addressValidationSuccess.type]: (_, { payload: resultsGroups }: PayloadAction<IAddressValidationResult[][]>) => {
    if (hasNoElements(resultsGroups)) {
      return [];
    }

    return resultsGroups;
  },
  [addressValidationDialog.type]: (state, { payload: isOpen }: PayloadAction<boolean>) => (isOpen ? state : [])
});

const cache = createReducer<IProject>(null, {
  [addressValidationCacheSet.type]: (_, { payload: project }) => project,
  [addressValidationDialog.type]: (state, { payload: isOpen }: PayloadAction<boolean>) => (isOpen ? state : null)
});

export const AddressValidation = combineReducers<IAddressValidation>({
  activeProjectId,
  activeProjectItemId,
  cache,
  results,
  showDialog
});
